import { MapPin, Quote } from "lucide-react";
import { ChapterHeading } from "./ChapterHeading";
import { Reveal } from "./Reveal";

export const Founder = () => (
    <section
        id="about"
        data-testid="founder-section"
        className="py-24 lg:py-32 bg-[#0A0E17]/60 border-y border-white/5 relative overflow-hidden"
    >
        <div
            className="absolute -bottom-32 -left-32 h-[26rem] w-[26rem] rounded-full bg-[#F5C518]/7 blur-[120px]"
            aria-hidden="true"
        />
        <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto relative">
            <ChapterHeading label="About Us" title="Meet the Founder" />
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-14 items-center">
                <Reveal className="lg:col-span-2">
                    <div className="relative max-w-sm mx-auto lg:mx-0">
                        <div
                            className="absolute -inset-3 rounded-[2rem] border border-[#F5C518]/25 rotate-2"
                            aria-hidden="true"
                        />
                        <div className="relative rounded-[1.7rem] overflow-hidden border border-white/15 shadow-[0_30px_80px_-25px_rgba(0,0,0,0.8)]">
                            <img
                                src="/assets/founder.png"
                                alt="Gaurav Pal — Founder of Animexa Tech Solutions"
                                data-testid="founder-photo"
                                className="w-full aspect-[4/5] object-cover object-top"
                            />
                            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#07090E]/95 via-[#07090E]/40 to-transparent p-5 pt-14">
                                <p className="font-display text-lg font-bold text-white">Gaurav Pal</p>
                                <p className="font-jbmono text-[10px] uppercase tracking-[0.22em] text-[#F5C518] mt-1">
                                    Founder &amp; Tech Creator
                                </p>
                            </div>
                        </div>
                        <div className="absolute -bottom-4 -right-3 sm:-right-6 glass rounded-2xl px-4 py-3 flex items-center gap-2.5 shadow-xl">
                            <MapPin size={15} className="text-[#00E5FF] shrink-0" />
                            <span className="text-xs text-slate-300">Dehradun, Uttarakhand</span>
                        </div>
                    </div>
                </Reveal>

                <Reveal delay={0.12} className="lg:col-span-3">
                    <div>
                        <Quote size={30} className="text-[#F5C518]/50 mb-5" aria-hidden="true" />
                        <p className="text-base sm:text-lg text-slate-300 leading-relaxed">
                            Gaurav Pal is the founder of Animexa Tech Solutions, focused on helping
                            businesses turn ideas into practical digital solutions using modern web
                            technologies, AI-assisted development and automation.
                        </p>
                        <p className="mt-5 text-sm sm:text-base text-slate-400 leading-relaxed">
                            Animexa was built with a simple goal: make modern technology more
                            accessible to businesses that want to establish, improve or automate
                            their digital presence.
                        </p>
                        <div className="mt-8 flex flex-wrap items-center gap-3">
                            {["Ideas", "Tech", "Growth"].map((w, i) => (
                                <span key={w} className="flex items-center gap-3">
                                    <span className="font-jbmono text-xs uppercase tracking-[0.25em] text-[#00E5FF]">
                                        {w}
                                    </span>
                                    {i < 2 && <span className="h-1 w-1 rounded-full bg-[#F5C518]" />}
                                </span>
                            ))}
                        </div>
                        <div className="mt-9 flex items-center gap-5 rounded-2xl border border-white/8 bg-[#0D131F] p-5">
                            <img
                                src="/assets/logo-mark.png"
                                alt="Animexa logo mark"
                                className="h-14 w-14 rounded-xl shrink-0"
                            />
                            <p className="text-xs sm:text-sm text-slate-400 leading-relaxed">
                                <span className="font-display font-bold text-white">ANIMEXA TECH SOLUTIONS</span>
                                <span className="block mt-1 text-[#F5C518]/90 italic">
                                    Turning Ideas into Digital Reality
                                </span>
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
